import React, { FC } from 'react';
import { t } from 'i18next';
import { useNonSpammyFieldState } from '@common/hooks';
import { notEmptyValidator } from '@common/utils';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

interface IDropOffDateField {
  multilegField?: string;
}

const DropOffDateField: FC<IDropOffDateField> = ({ multilegField }) => {
  const fieldName = multilegField ? `${multilegField}.dropoff_date` : 'dropoff_date';

  const { value: pickup_date } = useNonSpammyFieldState(
    multilegField ? `${multilegField}.pickup_date` : 'pickup_date',
  );

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-drop-off-date">
      <DateField
        className={css.input}
        label={t('bookingDetails.dropoffDate')}
        minDate={pickup_date as Date}
        name={fieldName}
        showMonthDropdown
        showYearDropdown
        validate={notEmptyValidator}
      />
    </div>
  );
};

export default DropOffDateField;
